import { render } from "./modal-login.vue?vue&type=template&id=21aa64aa&scoped=true"
import script from "./modal-login.vue?vue&type=script&lang=js"
export * from "./modal-login.vue?vue&type=script&lang=js"

import "./modal-login.vue?vue&type=style&index=0&id=21aa64aa&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21aa64aa"]])

export default __exports__